import { Button, FeedbackState } from '@webmotors/eleanor-ui';
import { ENV } from '@/app/config';
import { MY_ADS_PAGE, MY_ADS_TEST_IDS } from '../../utils';

const EmptyState = () => (
	<FeedbackState size="large" className="mx-auto" data-testid={MY_ADS_TEST_IDS.EMPTY_STATE}>
		<FeedbackState.Icon type="negative" />
		<FeedbackState.Title>{MY_ADS_PAGE.EMPTY_STATE.TITLE}</FeedbackState.Title>
		<FeedbackState.Description>{MY_ADS_PAGE.EMPTY_STATE.DESCRIPTION}</FeedbackState.Description>
		<FeedbackState.Actions>
			<Button
				variant="situational"
				size="medium"
				onClick={() => {
					window.open(ENV.URL_SELL, '_blank', 'noopener,noreferrer');
				}}
				data-testid={MY_ADS_TEST_IDS.EMPTY_STATE_CREATE_BUTTON}
			>
				{MY_ADS_PAGE.CREATE_AD_BUTTON}
			</Button>
		</FeedbackState.Actions>
	</FeedbackState>
);

EmptyState.displayName = 'EmptyState';

export { EmptyState };
